namespace app.upgraded {
    "use strict";

    export interface IUpgradedMenuItem {
        id: string;
        url: string;
        description: string;
        icon: string;
        menuItems: IUpgradedMenuItem[]
    }

    export interface IUpgradedMenu {
        id: string;
        description: string;
        logoutUrl: string;
        baseUrl: string;
        menuItems: IUpgradedMenuItem[]
    }

    export class UpgradedService {

        public frameUrl: string;
        private upgradedMenuItemsCache: IUpgradedMenu[] = [];

        /** @ngInject **/
        constructor(private $rootScope: ng.IRootScopeService, private $http: ng.IHttpService,
                private properties: app.support.constants.Properties, private msNavigationService,
                private $q: ng.IQService) {
            $rootScope.$on("user:logged", () => this.loadUpgradedMenuItems());
            $rootScope.$on("user:exited", () => this.logoutFromUpgraded());
            $rootScope.$on("user:exited", () => this.resetUpgradedMenuItems());
        }

        public loadUpgradedMenuItems(): void {
            this.upgradedMenuItems().then((menus) => {
                for (let menu of menus) {
                    if (menu.menuItems.length > 0) {
                        let id = "upgraded#" + menu.id;
                        this.msNavigationService.saveItem(id, {
                            title : menu.description,
                            translation : menu.description,
                            group : true,
                            weight : 5
                        });
                        this.fillSubmenus(menu.id, id, menu.menuItems);
                    }
                }
            });
            this.msNavigationService.sort();
        }

        private fillSubmenus(context: string, parentId: string, submenus: IUpgradedMenuItem[]) {
            for (let submenuItem of submenus) {
                let id = parentId + "." + submenuItem.id;
                let navigationMenu = {
                    title : submenuItem.description,
                    translation : "Consulta"
                };
                if (submenuItem.icon) {
                    navigationMenu["icon"] = submenuItem.icon;
                }
                if (submenuItem.url) {
                    navigationMenu["state"] = `app.upgraded({url: '${submenuItem.url}'})`;
                }
                this.msNavigationService.saveItem(id, navigationMenu);
                if (submenuItem.menuItems) {
                    this.fillSubmenus(context, id, submenuItem.menuItems);
                }
            }
        }

        public resetUpgradedMenuItems(): void {
            let navigation = this.msNavigationService.getNavigation();
            _.remove(<Array<any>>navigation, (nav) => nav._id.indexOf("upgraded#") === 0);
        }

        public upgradedMenuItems(): ng.IPromise<IUpgradedMenu[]> {
            if (!this.upgradedMenuItemsCache) {
                return this.$http.get(this.properties.apiUrl + "/integracoes-modulos/api/upgraded/menus")
                .then((response: ng.IHttpPromiseCallbackArg<IUpgradedMenu[]>) => {
                    this.upgradedMenuItemsCache = response.data;
                    return response.data;
                });
            } else {
                return this.$q.when(this.upgradedMenuItemsCache);
            }
        }
        
        public logoutFromUpgraded(): void {
            this.upgradedMenuItems().then((items) => {
                for (let legacyMenuItem of items) {
                    let request = {
                        method: "GET",
                        url: legacyMenuItem.baseUrl + "/" + legacyMenuItem.logoutUrl,
                        headers: this.emptyHeaders()
                    };
                    this.$http(request);
                }
            });
        }
        
        private emptyHeaders() {
            let headers = angular.copy(this.$http.defaults.headers.common);
            for (let key in headers) {
                headers[key] = undefined;
            }
            return headers;
        }

    }

    angular
        .module("app.upgraded")
        .service("app.upgraded.UpgradedService", UpgradedService);
}